import React from 'react'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import SurveyForm from './SurveyForm'

import { updateSurvey } from '../services'
import { handleError } from '../../../helpers'

export default function EditSurveyModal({ visible, onClose, reload, survey }) {
	const { register, handleSubmit, formState: { errors } } = useForm({
		defaultValues: { 
			name: survey.name,
			active: survey.active ? 1 : 0
		}
	})

	const onSubmit = values => {
		updateSurvey(survey.id, values)
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(error => handleError(error))
	}

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Actualizar Registro</ModalHeader>
				<ModalBody>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<SurveyForm register={register} errors={errors} survey={survey} />
						<Button color="primary" type="submit">Actualizar Registrar</Button>
					</Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}